import React, { useState } from "react";
import Layout from "../components/layouts/Layout";

const AwardsPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const awardsData = [
    {
      id: 1,
      title: "M-1グランプリ ナイスアマチュア賞",
      category: "entertainment",
      year: "2022",
      organization: "朝日放送テレビ・吉本興業",
      description: "お笑いコンビ「ペーパードライバーズ」として参加。1回戦「赤い糸を辿ってきました」のネタで注目を集め、2回戦では「マイコプラズマ」ネタで敗退となったものの、ナイスアマチュア賞を受賞。",
      recipient: "杉本迅（取締役COO）",
      significance: "エンターテインメント分野での創造性と表現力が評価された",
      image: "ENTERTAINMENT",
      details: [
        "日本最大級のお笑いコンテスト",
        "全国から数千組が参加する激戦区",
        "創造性とユーモアセンスの証明"
      ]
    },
    {
      id: 2,
      title: "スタートアップピッチイベント「荒波」Tech賞",
      category: "technology",
      year: "2021",
      organization: "スタートアップイベント主催団体",
      description: "DeepFake技術を活用したプロダクトでTech賞を受賞。革新的な技術活用と将来性が高く評価された。",
      recipient: "DeepRecommend株式会社（杉本迅 代表取締役CEO）",
      significance: "AI技術の実用化における先進性が認められた",
      image: "STARTUP",
      details: [
        "革新的なDeepFake技術の活用",
        "技術的優秀性の証明",
        "将来性の高いビジネスモデル"
      ]
    },
    {
      id: 3,
      title: "ふるさと納税最適化システム 技術表彰",
      category: "technology",
      year: "2024",
      organization: "自治体システム開発企業",
      description: "ナップザック問題を使用したふるさと納税量子最適化プログラムが技術面で高い評価を受け、表彰された。利用者と自治体双方の利益を最大化する革新的なアプローチが認められた。",
      recipient: "株式会社DeepTeLL",
      significance: "量子最適化技術の実用性と社会への貢献が評価された",
      image: "AWARD",
      details: [
        "量子最適化アルゴリズムの実用化",
        "社会課題解決への貢献",
        "技術革新性の証明"
      ]
    },
    {
      id: 4,
      title: "量子コンピューティングEXPO出展",
      category: "exhibition",
      year: "2023-2024",
      organization: "リード エグジビション ジャパン",
      description: "第4回量子コンピューティングEXPO春（2024年5月）および秋（2024年11月）に出展。生成AIプラットフォーム「Deepia」を展示し、多くの来場者から注目を集めた。",
      recipient: "株式会社DeepTeLL・DeepRecommend株式会社",
      significance: "量子技術分野での存在感とプロダクトの完成度が証明された",
      image: "EXHIBITION",
      details: [
        "日本最大級の量子技術展示会",
        "業界関係者への技術力アピール",
        "ビジネス機会の創出"
      ]
    },
    {
      id: 5,
      title: "第二回GPTsハッカソン 一次審査通過",
      category: "hackathon",
      year: "2023",
      organization: "GPTsハッカソン実行委員会",
      description: "生成AI技術を活用したソリューションで一次審査を通過。革新的なアイデアと実装力が評価された。",
      recipient: "杉本迅（株式会社STAR AI創業メンバーとして）",
      significance: "生成AI分野での技術力と創造性が認められた",
      image: "HACKATHON",
      details: [
        "生成AI技術の活用力",
        "短期間での開発力",
        "革新的なアイデア創出"
      ]
    },
    {
      id: 6,
      title: "電子書籍出版",
      category: "publication",
      year: "2021",
      organization: "Amazon Kindle",
      description: "『「その悩み、AIがすぐに答えを出します。」: 誰もが抱える人生の悩みへの新しい解決策』を出版。AI技術の普及と啓蒙活動の一環として執筆。",
      recipient: "杉本迅",
      significance: "AI知識の普及と社会への貢献活動",
      image: "PUBLICATION",
      details: [
        "AI技術の啓蒙活動",
        "一般向けの知識普及",
        "執筆・出版能力の証明"
      ]
    },
    {
      id: 7,
      title: "スポニチ新聞掲載",
      category: "media",
      year: "2020",
      organization: "スポーツニッポン新聞社",
      description: "Webサイト管理ツール「DeepLog」がスポニチ新聞に掲載された。若手起業家としての活動と革新的なプロダクトが注目された。",
      recipient: "杉本迅・DeepRecommend株式会社",
      significance: "メディアからの注目と社会的認知の獲得",
      image: "MEDIA",
      details: [
        "メディアでの技術紹介",
        "若手起業家としての注目",
        "プロダクトの革新性"
      ]
    },
    {
      id: 8,
      title: "パッションリーダーズ 入会",
      category: "organization",
      year: "2024",
      organization: "経済産業省後援",
      description: "経済産業省後援のパッションリーダーズに入会。次世代のリーダーとして認定された。",
      recipient: "杉本迅",
      significance: "政府機関からの次世代リーダーとしての認定",
      image: "ORGANIZATION",
      details: [
        "経済産業省後援組織",
        "次世代リーダーとしての認定",
        "政府からの期待"
      ]
    }
  ];

  const categories = [
    { key: 'all', label: '全て', icon: 'ALL' },
    { key: 'technology', label: '技術賞', icon: 'TECH' },
    { key: 'entertainment', label: 'エンターテインメント', icon: 'ENTERTAINMENT' },
    { key: 'exhibition', label: '展示会', icon: 'EXHIBITION' },
    { key: 'hackathon', label: 'ハッカソン', icon: 'HACKATHON' },
    { key: 'publication', label: '出版', icon: 'PUBLICATION' },
    { key: 'media', label: 'メディア', icon: 'MEDIA' },
    { key: 'organization', label: '組織・認定', icon: 'ORGANIZATION' }
  ];

  const filteredAwards = activeCategory === 'all' 
    ? awardsData 
    : awardsData.filter(award => award.category === activeCategory);

  const achievements = {
    totalAwards: awardsData.length,
    techAwards: awardsData.filter(a => a.category === 'technology').length,
    mediaAppearances: awardsData.filter(a => a.category === 'media').length,
    yearsActive: new Date().getFullYear() - 2020
  };

  return (
    <Layout 
      title="受賞歴・認証" 
      subtitle="DeepTeLLと創業メンバーの受賞歴・メディア掲載・認証実績"
    >
      {/* ヒーローセクション */}
      <section style={{ 
        padding: '65px 0 80px',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        position: 'relative'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center' }}>
              {/* 実績統計 */}
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '40px', 
                flexWrap: 'wrap',
                marginTop: '40px'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>{achievements.totalAwards}</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>受賞・掲載実績</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>{achievements.techAwards}</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>技術賞</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>{achievements.yearsActive}+</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>年間の活動</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* カテゴリーフィルター */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                  {categories.map((category) => (
                    <button
                      key={category.key}
                      onClick={() => setActiveCategory(category.key)}
                      style={{
                        padding: '12px 24px',
                        borderRadius: '25px',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        background: activeCategory === category.key ? '#3b82f6' : 'transparent',
                        color: activeCategory === category.key ? 'white' : '#cbd5e1',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        fontSize: '16px'
                      }}
                    >
                      {category.icon} {category.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 受賞歴一覧 */}
      <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12" style={{ marginBottom: '40px' }}>
              <h2 style={{ color: '#f1f5f9', textAlign: 'center' }}>
                {categories.find(cat => cat.key === activeCategory)?.icon} {categories.find(cat => cat.key === activeCategory)?.label}
                <span style={{ color: '#94a3b8', fontSize: '18px', marginLeft: '15px' }}>
                  ({filteredAwards.length}件)
                </span>
              </h2>
            </div>
          </div>

          <div className="row">
            {filteredAwards.map((award) => (
              <div key={award.id} className="col-md-6" style={{ marginBottom: '40px' }}>
                <div style={{ 
                  padding: '30px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '20px' }}>
                    <div style={{ fontSize: '48px', marginRight: '20px' }}>{award.image}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                        <span style={{ 
                          background: 'rgba(59, 130, 246, 0.2)',
                          color: '#3b82f6',
                          padding: '4px 12px',
                          borderRadius: '12px',
                          fontSize: '12px'
                        }}>
                          {award.year}
                        </span>
                      </div>
                      <h3 style={{ color: '#f1f5f9', marginBottom: '10px', fontSize: '20px' }}>
                        {award.title}
                      </h3>
                      <p style={{ color: '#94a3b8', fontSize: '14px', marginBottom: '15px' }}>
                        {award.organization}
                      </p>
                    </div>
                  </div>

                  <p style={{ color: '#cbd5e1', lineHeight: '1.6', marginBottom: '20px', fontSize: '14px' }}>
                    {award.description}
                  </p>

                  <div style={{ marginBottom: '20px' }}>
                    <h6 style={{ color: '#3b82f6', marginBottom: '10px', fontSize: '14px' }}>受賞者</h6>
                    <p style={{ color: '#cbd5e1', fontSize: '13px', margin: 0 }}>
                      {award.recipient}
                    </p>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <h6 style={{ color: '#3b82f6', marginBottom: '10px', fontSize: '14px' }}>意義</h6>
                    <p style={{ color: '#cbd5e1', fontSize: '13px', margin: 0 }}>
                      {award.significance}
                    </p>
                  </div>

                  <div>
                    <h6 style={{ color: '#3b82f6', marginBottom: '10px', fontSize: '14px' }}>詳細</h6>
                    <ul style={{ color: '#cbd5e1', fontSize: '13px', paddingLeft: '15px', margin: 0 }}>
                      {award.details.map((detail, index) => (
                        <li key={index} style={{ marginBottom: '3px' }}>
                          {detail}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* タイムライン */}
      <section style={{ padding: '80px 0', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: '#f1f5f9', textAlign: 'center', marginBottom: '50px' }}>
                受賞歴タイムライン
              </h2>
              
              <div style={{ position: 'relative' }}>
                {/* タイムライン線 */}
                <div style={{
                  position: 'absolute',
                  left: '30px',
                  top: '0',
                  bottom: '0',
                  width: '2px',
                  background: 'linear-gradient(to bottom, #3b82f6, #1d4ed8)',
                  borderRadius: '1px'
                }}></div>

                {awardsData
                  .sort((a, b) => parseInt(b.year) - parseInt(a.year))
                  .map((award, index) => (
                    <div key={award.id} style={{ 
                      display: 'flex', 
                      alignItems: 'flex-start', 
                      marginBottom: '40px',
                      position: 'relative'
                    }}>
                      {/* タイムライン点 */}
                      <div style={{
                        width: '12px',
                        height: '12px',
                        background: '#3b82f6',
                        borderRadius: '50%',
                        marginRight: '30px',
                        marginTop: '8px',
                        position: 'relative',
                        zIndex: 1,
                        border: '3px solid #0f172a'
                      }}></div>

                      <div style={{ flex: 1 }}>
                        <div style={{ 
                          background: 'rgba(30, 41, 59, 0.8)',
                          padding: '20px',
                          borderRadius: '8px',
                          border: '1px solid rgba(59, 130, 246, 0.2)'
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <span style={{ 
                              background: 'rgba(59, 130, 246, 0.2)',
                              color: '#3b82f6',
                              padding: '4px 12px',
                              borderRadius: '12px',
                              fontSize: '12px',
                              fontWeight: '600'
                            }}>
                              {award.year}
                            </span>
                            <span style={{ fontSize: '20px' }}>{award.image}</span>
                          </div>
                          <h4 style={{ color: '#f1f5f9', marginBottom: '8px' }}>
                            {award.title}
                          </h4>
                          <p style={{ color: '#94a3b8', fontSize: '14px', margin: 0 }}>
                            {award.organization}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ 
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                私たちと一緒に新しい実績を作りませんか？
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                技術力と創造性で、次の受賞を目指し<br />
                共に成長していけるパートナーを募集しています。
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
                <a href="/partnership" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                  🤝 パートナーになる
                </a>
                <a href="/careers" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  border: '2px solid white',
                  color: '#1e40af'
                }}>
                                      採用情報を見る
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AwardsPage; 